// extracted by mini-css-extract-plugin
export var bodySections = "_ch-8";
export var gray = "_ch-7";
export var green = "_ch-4";
export var iconContainer = "_ch-9";
export var iconWidgetContainer = "_ch-1";
export var phoneIcon = "_ch-2";
export var red = "_ch-5";
export var statusDot = "_ch-3";
export var widgetContainer = "_ch-0";
export var yellow = "_ch-6";